import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EnvelopeComponent } from '@pcplus/infrastructure';
import {
  AuthGuard,
  LoginComponent,
  SwitchCustomerComponent
} from '@pcplus/security';
import { VersionComponent } from '@pcplus/security';
import { MobileRegistrationComponent } from './components/mobile-registration/mobile-registration.component';
import { PendingRegistrationsComponent } from './components/protected-resources/pending-registrations/pending-registrations.component';
import { ProtectedResourceComponent } from './components/protected-resources/protected-resource/protected-resource.component';
import { ProtectedResourcesComponent } from './components/protected-resources/protected-resources/protected-resources.component';
import { RegisteredUsersComponent } from './components/protected-resources/registered-users/registered-users.component';
import { SimulateLoginComponent } from './components/simulate-login/simulate-login.component';

const routes: Routes = [
  {
    path: '',
    component: EnvelopeComponent,
    children: [
      {
        path: '',
        outlet: 'sidemenu-start-content',
        component: SwitchCustomerComponent
      },
      {
        path: '',
        outlet: 'sidemenu-end-content',
        component: VersionComponent
      },
      { path: '', redirectTo: '/activities/dashboard', pathMatch: 'full' },

      { path: 'login', component: LoginComponent },

      // { path: 'register', component: RegisterComponent },
      // { path: 'reset', component: ResetComponent },
      // { path: 'subscribe', component: PaymentComponent },
      {
        path: 'security',
        loadChildren: () =>
          import('@pcplus/management').then((m) => m.ManagementModule),
        canActivate: [AuthGuard]
      },
      // {
      //   path: 'sharedFiles',
      //   component: SharedFilesComponent
      // },
      // {
      //   path: 'sharedFiles/:shareFolderId',
      //   component: ExplorerComponent
      // },

      {
        path: 'activities',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('@pcplus/activities').then((m) => m.ActivitiesModule)
      },
      {
        path: 'protected-resources',
        canActivate: [AuthGuard],
        component: ProtectedResourcesComponent
      },
      {
        path: 'protected-resources/:id',
        canActivate: [AuthGuard],
        component: ProtectedResourceComponent
      },
      {
        path: 'protected-resources/:id/pending',
        canActivate: [AuthGuard],
        component: PendingRegistrationsComponent
      },
      {
        path: 'protected-resources/:id/registered',
        canActivate: [AuthGuard],
        component: RegisteredUsersComponent
      },
      {
        path: 'mfa-users/:email/pending',
        canActivate: [AuthGuard],
        component: PendingRegistrationsComponent
      },
      {
        path: 'mfa-users/:email/registered',
        canActivate: [AuthGuard],
        component: RegisteredUsersComponent
      },
      {
        path: 'settings',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('./settings/settings.module').then((m) => m.SettingsModule)
      },
      {
        path: 'clientSettings',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('@pcplus/services-common').then((m) => m.ServicesCommonModule)
      },
      {
        path: 'licensing',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('@pcplus/licensing').then((m) => m.LicensingModule)
      }
    ]
  },
  {
    path: 'mobile-registration/:id',
    component: MobileRegistrationComponent
  },
  {
    path: 'simulate-login/:id',
    component: SimulateLoginComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
